import { Resource } from 'i18next';

export const unSanitizeLocalization = (data: Resource) => {
  const unSanitizedData = JSON.stringify(data).replace(/&lt;/g, '<').replace(/&gt;/g, '>');

  return JSON.parse(unSanitizedData);
};
